module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userInfoChange"
    }
  }, [_c('div', {
    staticClass: "userInfoChangeBox"
  }, [_c('div', {
    staticClass: "editInfoItem"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "editInfoItem_label"
  }, [_vm._v("户号")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入户号",
      "maxlength": 12,
      "disabled": _vm.type == 3 || _vm.type == 2
    },
    on: {
      "blur": _vm.onblur
    },
    model: {
      value: (_vm.dataset.account),
      callback: function($$v) {
        _vm.$set(_vm.dataset, "account", $$v)
      },
      expression: "dataset.account"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "editInfoItem_label"
  }, [_vm._v("缴费金额")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入缴费金额",
      "disabled": _vm.type == 3,
      "maxlength": 11
    },
    model: {
      value: (_vm.dataset.money),
      callback: function($$v) {
        _vm.$set(_vm.dataset, "money", $$v)
      },
      expression: "dataset.money"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "editInfoItem_label"
  }, [_vm._v("费用周期")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始时间",
      "disabled": _vm.type == 3
    },
    model: {
      value: (_vm.dataset.begin_date),
      callback: function($$v) {
        _vm.$set(_vm.dataset, "begin_date", $$v)
      },
      expression: "dataset.begin_date"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "结束时间",
      "disabled": _vm.type == 3
    },
    model: {
      value: (_vm.dataset.end_date),
      callback: function($$v) {
        _vm.$set(_vm.dataset, "end_date", $$v)
      },
      expression: "dataset.end_date"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "editInfoItem_label"
  }, [_vm._v("缴费明细")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入缴费明细",
      "disabled": _vm.type == 3
    },
    model: {
      value: (_vm.dataset.payment_detail),
      callback: function($$v) {
        _vm.$set(_vm.dataset, "payment_detail", $$v)
      },
      expression: "dataset.payment_detail"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "editInfoItem_label"
  }, [_vm._v("备注")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入备注",
      "disabled": _vm.type == 3
    },
    model: {
      value: (_vm.dataset.remark),
      callback: function($$v) {
        _vm.$set(_vm.dataset, "remark", $$v)
      },
      expression: "dataset.remark"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "editInfoItem",
    class: _vm.type == 3 ? 'dis' : '',
    staticStyle: {
      "text-ailgn": "center"
    }
  }, [(_vm.type != 3) ? _c('el-button', {
    staticStyle: {
      "width": "120px",
      "margin-left": "330px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "120px",
      "margin-bottom": "20px",
      "margin-left": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('onClose')
      }
    }
  }, [_vm._v("关闭")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5dd9ecae"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/PropertyInfoChangeEdit.vue
// module id = 537
// module chunks = 1